import { render, staticRenderFns } from "./SearchPostIndexView.vue?vue&type=template&id=ebb0a814&scoped=true"
import script from "./SearchPostIndexView.vue?vue&type=script&lang=js"
export * from "./SearchPostIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb0a814",
  null
  
)

export default component.exports